import { trigger, state, style, transition, animate } from "@angular/animations";

export const verticalSlideToggle = trigger("verticalSlideToggle", [
  state(
    "closed",
    style({
      height: "0",
      overflow: "hidden",
    })
  ),
  state(
    "open",
    style({
      height: "*",
      overflow: "hidden",
    })
  ),
  transition("closed <=> open", animate("300ms ease-in-out")),
]);

export const horizontalSlideToggle = trigger("horizontalSlideToggle", [
  state(
    "closed",
    style({
      width: "0",
      // dislay: "none",
      overflow: "hidden",
    })
  ),
  state(
    "open",
    style({
      width: "*",
      // display: "*",
      overflow: "hidden",
    })
  ),
  transition("closed <=> open", animate("300ms ease-in-out")),
]);
